import { ColumnResize, ColumnResizeConfig } from "@bryntum/schedulerpro";

export const columnResizeFeature = {
    disabled: true,
} satisfies Partial<ColumnResizeConfig> | ColumnResize;
